import React, { ReactNode } from 'react';
import Carousel from 'components/UI/V2/Carousel/Carousel';
import DefaultHeader from 'components/UI/V3/DefaultHeader/DefaultHeader';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { getDaycareSlides } from './Slides';
import styles from './DaycareComponent.module.scss';

interface DaycareOnboardingProps {
    onAddService: () => void;
    headerRightContent?: ReactNode;
}

const DaycareOnboarding = ({ onAddService, headerRightContent }: DaycareOnboardingProps) => (
    <div className={styles.root}>
        <div
            className={styles.headWrapper}
            style={{ backgroundColor: '#ffffff' }}
        >
            <DefaultHeader
                title="Daycare Services"
                buttonLabel="Add Service"
                displayButton={true}
                onClick={onAddService}
                className={styles.headerContainer}
                buttonIcon={faPlus}
                customButton={headerRightContent}
            />
        </div>
        <div style={{ display: 'flex', justifyContent: 'center', padding: '24px 0 40px' }}>
            <Carousel slides={getDaycareSlides()} />
        </div>
    </div>
);

export default DaycareOnboarding;
